<template>
    <modal ref="downloadCaptionModal">
        <!--モーダルタイトル-->
        <template v-slot:modalTitle>
            <span>ファイルのダウンロード</span>
        </template>
        <!--モーダル内のコンテンツ-->
        <template v-slot:modal-content="{ closeModal }">
            <!-- 字幕DLか焼き付けDLかを示すタブ -->
            <div class="d-flex justify-content-evenly">
                <img
                    @click="this.downloadType = 1"
                    :src="isSubtitleEmbed ? '/img/subtitle-download-selected.svg' : '/img/subtitle-download-unselected.svg'"
                    style="width: 30%;"
                >
                <img
                    @click="this.downloadType = 4"
                    :src="isSubtitleEmbed ? '/img/video-download-unselected.svg' : '/img/video-download-selected.svg'"
                    style="width: 30%;"
                >
            </div>

            <!-- 字幕DLのとき -->
            <div v-if="!isSubtitleEmbed">
                <div class="mb-4">
                    <label class="form-label">ダウンロード形式</label><br />
                    <div style="  display: flex; align-items: center;">
                        <select class="lang-pair-select" v-model="downloadType">
                            <option v-for="(downloadType, index) in downloadTypes" :key="index"
                                :value="downloadType.id">
                                {{ downloadType.title }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="modal-btn d-flex justify-content-evenly">
                    <div>
                        <button class="btn btn-red" @click="closeDownloadModal">キャンセル</button>
                    </div>
                    <div>
                        <button id="downloadButton" class="btn btn-purple" @click="downloadSubtitle">
                            ダウンロード
                        </button>
                    </div>
                </div>
            </div>
            <!-- 字幕焼き付けDLのとき -->
            <div v-else>
                <p v-show="localSubtitleEmbedstatus === 'before'" class="embed-subtitle-status">
                    状態 : 字幕焼き付け前<br>
                    動画をダウンロードするには「焼き付け実行」を押してください
                </p>
                <p v-show="localSubtitleEmbedstatus === 'progress'" class="embed-subtitle-status">
                    状態 : ファイル作成中<br>
                    焼き付けが完了するまでお待ちください
                </p>
                <p v-show="localSubtitleEmbedstatus === 'embedded'" class="embed-subtitle-status">
                    状態 : 動画作成完了（作成日：{{ this.localSubtitleEmbeddedAt }}）<br>
                    「ダウンロード」ボタンより動画を保存できます
                </p>
                <p v-show="localSubtitleEmbedstatus === 'failed'" class="embed-subtitle-status">
                    状態 : 字幕焼き付け失敗<br>
                    再度動画をダウンロードするには「焼き付け実行」を押してください
                </p>

                <div class="modal-btn d-flex justify-content-evenly">
                    <div v-if="localSubtitleEmbedstatus === 'before' || localSubtitleEmbedstatus === 'embedded' || localSubtitleEmbedstatus === 'failed'">
                        <button class="btn btn-red" @click="embedSubtitleToVideo">焼き付け実行</button>
                    </div>
                    <div v-if="localSubtitleEmbedstatus === 'progress'">
                        <button class="btn btn-red" disabled>ファイル作成中...</button>
                    </div>

                    <div v-if="localSubtitleEmbedstatus === 'embedded'">
                        <button class="btn btn-purple" @click="downloadSubtitleEmbeddedVideo">ダウンロード</button>
                    </div>
                    <div v-else>
                        <button class="btn btn-purple disabled">ダウンロード</button>
                    </div>
                </div>
            </div>

        </template>
    </modal>
</template>

<script>
import modal from '@/Pages/Components/modal.vue';
import axios from 'axios';

export default {
    components: {
        modal
    },

    props: {
        downloadTypes: {
            type: Array,
            required: true
        },
        downloadVideoId: {
            type: Number,
            required: true
        },
    },

    data() {
        return {
            downloadType: 1,
            downloadVideoId: 0, // undefinedだとziggyのrouteでエラーになるの1を設定
            isSubtitleEmbed: false, //字幕焼き付けDLかどうか
            localSubtitleEmbedstatus: 'before', // 字幕焼き付けの状態
            localSubtitleEmbeddedAt: '' // 字幕焼き付け完了日時
        }
    },

    methods: {
        async openDownloadModal(id, subtitleEmbedStatus, subtitleEmbeddedAt) {
            this.$refs.downloadCaptionModal.openModal();
            this.downloadVideoId = id;
            // APIから最新状態を取得
            try {
                const response = await axios.get(route('video_translate.get_subtitle_embed_status', { id: id }));
                this.localSubtitleEmbedstatus = response.data.status || 'before';
                this.localSubtitleEmbeddedAt = this.localizeDateSubtitleEmbeddedAt(response.data.embedded_at);
            } catch (e) {
                // エラー時は従来通りpropsからセット
                this.localSubtitleEmbedstatus = subtitleEmbedStatus;
                this.localSubtitleEmbeddedAt = this.localizeDateSubtitleEmbeddedAt(subtitleEmbeddedAt);
            }
        },
        closeDownloadModal(id) {
            this.$refs.downloadCaptionModal.closeModal();
            this.downloadVideoId = 0;
            this.downloadType = 1;
        },

        downloadSubtitle() {
            window.location.href = this.getDownloadUrl();
        },
        getDownloadUrl() {
            return route('video_translate.download', { id: this.downloadVideoId, type: this.downloadType });
        },

        embedSubtitleToVideo() {
            this.localSubtitleEmbedstatus = 'progress';
            axios.post(route('video_translate.embed_subtitle_to_video', { id: this.downloadVideoId }))
                .catch(() => {
                    alert('字幕焼き付けに失敗しました');
                    this.localSubtitleEmbedstatus = 'before';
                });
        },
        downloadSubtitleEmbeddedVideo() {
            // 現時点では downloadSubtitle() と同様の処理だが、形式ごとの処理差異が発生することを見越して別メソッドとして定義 (共通化も検討)
            window.location.href = this.getDownloadUrl();
        },
        checkDownloadComplete() {
            const interval = setInterval(() => {
                if (document.cookie.includes('downloadCompleted=true')) {
                    clearInterval(interval);
                    this.onDownloadComplete();
                }
            }, 1000); // 1秒ごとにチェック
        },
        onDownloadComplete() {
            // 非活性化を解除
            downloadButton.disabled = false;
            downloadButton.innerText = 'ダウンロード';
            // クッキーを削除
            document.cookie = 'downloadCompleted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        },
        localizeDateSubtitleEmbeddedAt(subtitleEmbeddedAt) {
            if (!subtitleEmbeddedAt) return '';

            try {
                // 入力をISO 8601形式に変換
                const isoDate = subtitleEmbeddedAt.replace(' ', 'T') + 'Z'; // UTCを明示するために 'Z' を追加

                // ISO 8601形式の日時をローカルの日時に変換
                const date = new Date(isoDate);
                return date.toLocaleString();
            } catch (error) {
                console.error('日時の変換に失敗しました:', error);
                return '無効な日時';
            }
        },
    },
    computed: {
        isSubtitleEmbed() {
            return this.downloadType === 4;
        }
    }
}
</script>


<style>
.lang-pair-select {
    -webkit-appearance: none;
    appearance: none;
    /* デフォルトの矢印を無効 */
    color: #999;
    font-size: 1rem;
    padding: 0.4rem 2.4rem 0.4rem 0.4rem;

    background-image: url(/img/16_tri.svg);
    background-repeat: no-repeat;
    background-size: 1.3rem;
    background-position: right 0.2rem center;

    border: 1px solid #ced4da;
    border-radius: 0.2rem;
}

.lang-pair-select::-ms-expand {
    display: none;
    /* デフォルトの矢印を無効(IE用) */
}

.embed-subtitle-status {
    line-height: 2.5;
    /* 焼き付け状態のテキスト行間を設定。モーダルのサイズを一定にするため */
}

</style>